<template>
    <div v-if="isShow" :style="domStyle">
        <div class="title_style"><span class="title_text_style">{{title}}</span><Icon :class="title_icon" type="ios-arrow-forward" size="20" /></div>
        <div class="title_content">
            <div v-for="val,key in list" :key="key" :style="menu_content">
                <div :style="menu_list">
                    <span class="title_text_top" :style = "{background: val.background,border:val.border + 'px solid #000',color:val.numcolor,borderRadius:'50%'}">{{val.num}}</span>
                    <p class="text_flow" :style="{color:val.color}" :title="val.title">{{val.title}}</p>
                </div>
            </div>
        </div>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<script>
export default {
    name : "",
    props : ["primitives","fvSystemApi","parentObject"],
    created(){
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : this.x + "px",
            top : this.y + "px",
            width : this.width + "px",
            height : this.height + "px",
        }
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5"
        }
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
    },
    data(){
        return {
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
        }
    },
    computed: {
        list(){
            if(!this.infoList){
                return [];
            }else{
                return this.infoList;
            }
        },
        menu_list(){
            return {
                width : 100 + "%",
                height: 100 + "%",
                display: "flex",
                justifyContent: "center",
                float:"left",
                alignItems: "center",
                flexDirection: "column"
            }
        },
        menu_content(){
            if(!this.infoList) return;
            if(this.infoList.length > 4){
                return {
                    minWidth : this.parentObject.$refs.dialog.$refs.content.offsetWidth / 4 + "px",
                    height   : 100 + "%",
                    alignItems: "center",
                    display : 'inline-block'
                }
            }else{
                return {
                    minWidth : this.parentObject.$refs.dialog.$refs.content.offsetWidth / this.infoList.length + "px",
                    height   : 100 + "%",
                    alignItems: "center",
                    display  : "inline-block"
                }
            }
        },
        title_icon(){
            if(!this.infoList) return 'title_icon_never';
            if(this.infoList.length > 4){
                return 'title_icon_show'
            }else{
                return 'title_icon_never'
            }
        }
    },
    methods : {
        /*
            参数：src 原json数据
            作用：混淆数据到当前对象
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e,domScale){},
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            if(this.isEnable) return;
        },
        /*
            参数：无
            作用：所在窗口关闭时调用（vue生命周期函数销毁窗口之前调用）
        */
        onClose(){
            return new Promise((resolve)=>{
                resolve();
            })
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            if(this.fontSize){
                this.$el.style.fontSize = parseInt(parseInt(this.fontSize.substr(0, this.fontSize.length - 2)) * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + "px"; 
            }
            this.$el.style.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.$el.style.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";
            this.$el.style.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.$el.style.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            if(parseInt(this.height * (scaleObj.sy + scaleObj.zoom))<18){
                this.$el.style.height = 18 + "px";
            }else{
                this.$el.style.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            }
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
        },
        /*
            参数：index需要修改的下标 num 设置数值
            作用：徽标展示值变更
        */
        SetLogoShow(index,num){
            var val = Number(index - 1);
            this.infoList[val].num = num;
            this.$forceUpdate();
        }
    }
}
</script>

<style>
    .title_style{
        min-height: 30%;
        display: flex;
        justify-content: space-between;
        border-bottom:1px solid #285DE8;;
    }
    .title_text_style{
        border-bottom:2px solid #285DE8;
        color : #285DE8;
        padding-left:10px;
    }
    .title_content{
        min-height:70%;
        display: flex;
        overflow-x: auto;
        align-items: center;
        justify-content: space-between;
    }
    .title_content::-webkit-scrollbar {
        width:0px;
        height:0px;
    }
    .title_text_top{
       min-width: 20px;
       min-height:20px;
       line-height:20px;
       text-align:center;
    } 
    .title_icon_show{
        display:inline-block;
    }
    .title_icon_never{
        display: none;
    }
    .text_flow{
        overflow:hidden;
        width:100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/primitives/fvInfoExhibition/fvInfoExhibition.vue